module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc017b13bb5d8731ae93.worker.js");
};